import { Box, type Theme, useMediaQuery } from '@mui/material';
import type { ReactNode } from 'react';
import React from 'react';

import { spaces } from '../../assets/styles/themes/tokens';

interface MainGridArea {
	body?: ReactNode;
}

const MainGridArea: React.FunctionComponent<MainGridArea> = ({ body }) => {
	const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('mobile'));
	const isTablet = useMediaQuery((theme: Theme) => theme.breakpoints.between('mobile', 'tablet'));

	const getPadding = () => {
		if (isMobile) return spaces.md;
		if (isTablet) return spaces.lg;
		return spaces.xl;
	};

	const NewPageContainer = () => {
		return (
			<Box
				sx={{
					paddingLeft: getPadding(),
					paddingRight: getPadding(),
				}}
				data-testid="main-grid-area__body"
			>
				{body}
			</Box>
		);
	};

	return (
		<Box
			sx={{
				display: 'grid',
				overflow: 'hidden',
				position: 'relative',
				height: '100%',
				gridTemplateColumns: '100%',
				gridTemplateRows: '0 1fr',
				gridTemplateAreas: `
          "header"
          "body"
        `,
				'@media (min-width: 768px)': {
					display: 'grid',
					gridTemplateColumns: '1fr',
					gridTemplateAreas: `
            "header"
            "body"
          `,
				},
			}}
		>
			{
				<Box
					component="header"
					sx={{
						gridArea: 'header',
						borderBottom: '1px solid #dee2e6',
						height: '100%',
					}}
				/>
			}
			<NewPageContainer />
		</Box>
	);
};

export default MainGridArea;
